module.exports = __webpack_public_path__ + "img/tarj2-13.68247896.svg";